export class AiListModel {
    Id: number;
    Label: string;
    Value: string;
}